export default function ErrorNotice({ message }) {
  if (!message) return null
  return (
    <div className="mb-4 flex gap-2 rounded-2xl border border-red-200 bg-red-50/90 p-3.5 backdrop-blur animate-fade-in">
      <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path strokeLinecap="round" d="M12 8v5M12 16h.01" />
      </svg>
      <p className="text-sm leading-relaxed text-red-700">{message}</p>
    </div>
  )
}
